import React, { useMemo, useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

/* ------------------ Helpers intégrés ------------------ */
function getProjet(num) {
  let Pr, numVideo, numSrc, ShowSite, Tools = [], SwitchSrc = [], Title;
  if (num === 0) {
    Pr = '/assets/Static/IMG/Projets/Pr1.png';
    numVideo = "https://drive.google.com/file/d/1j4dhOL3SuS1tBgS6gG4TCaaVtATV98Ky/preview";
    numSrc = "https://dep-abce.onrender.com/";
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr1/Pr1-1.png','/assets/Static/IMG/Projets/Pr1/Pr1-2.png','/assets/Static/IMG/Projets/Pr1/Pr1-3.png','/assets/Static/IMG/Projets/Pr1/Pr1-4.png'];
    Tools = ["python","flask","javascript","chartjs","sqlite"];
    Title = "Précision KPI et réalisation des dashboards pour le Suivi des engins";
  } else if (num === 1) {
    Pr = '/assets/Static/IMG/Projets/Pr9 .png';
    numVideo = "https://drive.google.com/file/d/1IWAw1gIp9IIPMZqt7SbRCUxyMJq0EIE0/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["react","flask","smpt","postgresql","render"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr9/Pr9-1 .png','/assets/Static/IMG/Projets/Pr9/Pr9-2 .png','/assets/Static/IMG/Projets/Pr9/Pr9-3 .png','/assets/Static/IMG/Projets/Pr9/Pr9-4 .png'];
    Title = "Système de recommandation des formations et Ensakh Chatbot";
  } else if (num === 5) {
    Pr = '/assets/Static/IMG/Projets/Pr3.png';
    numVideo = "https://drive.google.com/file/d/1Mb5bYaW3ZW-PNBA4HECcy-McjIKOf7n6/preview";
    numSrc = "http://store-samzi.kesug.com/";
    Tools = ["html","boostrap","laravel","mysql"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr3/Pr3-1.png','/assets/Static/IMG/Projets/Pr3/Pr3-2.png','/assets/Static/IMG/Projets/Pr3/Pr3-3.png','/assets/Static/IMG/Projets/Pr3/Pr3-4.png'];
    Title = "Samzi E-Commerce website";
  } else if (num === 3) {
    Pr = '/assets/Static/IMG/Projets/Pr4.png';
    numVideo = "https://drive.google.com/file/d/1bIEKWZZhlVOsuzgQFxnZJK0OoFXBXoEI/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["html","boostrap","react","springboot","mysql"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr4/Pr4-1.png','/assets/Static/IMG/Projets/Pr4/Pr4-2.png','/assets/Static/IMG/Projets/Pr4/Pr4-3.png','/assets/Static/IMG/Projets/Pr4/Pr4-4.png'];
    Title = "Gestion des notes website";
  } else if (num === 7) {
    Pr = '/assets/Static/IMG/Projets/Pr5 .jpg';
    numVideo = "https://drive.google.com/file/d/1_dV2yF3BMLIF644f4xkO0SznH5gsT-o0/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["react","flask","smpt","postgresql","render"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr5/Pr5-1 .png','/assets/Static/IMG/Projets/Pr5/Pr5-2 .png','/assets/Static/IMG/Projets/Pr5/Pr5-3 .png','/assets/Static/IMG/Projets/Pr5/Pr5-4 .png'];
    Title = "site web pour l'inspection mécaniques des engins";
  } else if (num === 8) {
    Pr = '/assets/Static/IMG/Projets/Pr6 .png';
    numVideo = "https://drive.google.com/file/d/1sy2iPgO0L07DyIFvRI-OtfIIoFIA5bFV/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["react","flask","paddleocr","postgresql","render"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr6/Pr6-1 .PNG','/assets/Static/IMG/Projets/Pr6/Pr6-2 .PNG','/assets/Static/IMG/Projets/Pr6/Pr6-3 .PNG','/assets/Static/IMG/Projets/Pr6/Pr6-4 .PNG'];
    Title = "site web :Suivi des SE-Engins pour la maintenance (OCR registres papier)";
  } else if (num === 6) {
    Pr = '/assets/Static/IMG/Projets/Pr7 .png';
    numVideo = "https://drive.google.com/file/d/1QOsK8ETkIA6PrfFAW4831l-zdVDC3EoC/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["react","flask","smpt","sqlite"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Pr7/Pr7-1 .png','/assets/Static/IMG/Projets/Pr7/Pr7-2 .png','/assets/Static/IMG/Projets/Pr7/Pr7-3 .png','/assets/Static/IMG/Projets/Pr7/Pr7-4 .png'];
    Title = "Suivi de la performance des ordres de travail";
  } else if (num === 4 ) {
    // Nouveau projet : remplacer le titre et renseigner les technologies ci-dessous.
    // Aucune image locale n'est nécessaire : la carte affiche un aperçu vidéo.
    Pr = "/assets/Static/IMG/Projets/Capture d’écran 2026-10-11 150645.png";
    numVideo = "https://drive.google.com/file/d/1eZ4rfvu1u3exVAPwOsXYStR7uSV3JKLP/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["Power BI", "DAX", "Power Query (M)", "Power BI Service"]; // Exemple : ["Power BI", "React", "PostgreSQL"]
    SwitchSrc = [];
    Title = "Rapport Power BI multi-pages pour l’analyse des ventes et des clients";
  } else if (num === 2) {
    Pr = '/assets/Static/IMG/Projets/WhatsApp Image 2025-11-17 at 18.20.38.jpeg';
    numVideo = "https://drive.google.com/file/d/1AMHp7B2WONe5b_aQuQwk8lnggf3jMD1n/preview";
    numSrc = ""; ShowSite = false;
    Tools = ["PowerBI","SSAS","SSIS","SQL Server"];
    SwitchSrc = ['/assets/Static/IMG/Projets/Capture d’écran 2026-10-11 150645.png','/assets/Static/IMG/Projets/Capture d’écran 2026-10-11 150645.png','/assets/Static/IMG/Projets/Capture d’écran 2026-10-11 150645.png','/assets/Static/IMG/Projets/Capture d’écran 2026-10-11 150645.png'];
    Title = " Analyse des effets indésirables des médicaments via un Data Warehouse";
  }
  return [Pr, numVideo, numSrc, ShowSite, Tools, SwitchSrc, Title];
}

/* ----------------------------------------------------- */

export default function ProjetsGrid() {
  const projects = useMemo(
    () =>
      Array.from({ length: 9 }, (_, i) => {
        const [image, videoUrl, siteUrl, showSite, tools, gallery, title] = getProjet(i);
        return { id: i, image, videoUrl, siteUrl, showSite, tools, gallery, title };
      }),
    []
  );

  // IDs pour lesquels on masque la vidéo
  const HIDE_VIDEO_IDS = new Set([7, 8, 6]);

  const [playingId, setPlayingId] = useState(null);
  const frameRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setPlayingId(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div id="projects" className="w-full mx-auto min-h-screen py-8">
      <div className="max-w-screen-2xl mx-auto px-10 md:px-10 lg:px-20">

        <div className="grid [grid-template-columns:repeat(auto-fit,minmax(360px,1fr))] gap-8">
          {projects.map((p) => {
            const videoAllowed = !!p.videoUrl && !HIDE_VIDEO_IDS.has(p.id);
            const isPlaying = playingId === p.id && videoAllowed;

            return (
              <motion.article
                key={p.id}
                className="h-full group bg-[#1e1f25] border border-[#2b2c33] rounded-2xl shadow-lg overflow-hidden flex flex-col"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.3 }}
              >
                {/* --- Média (unique) --- */}
                <div className="relative">
                  {isPlaying ? (
                    <div className="aspect-[16/9] w-full bg-black">
                      <iframe
                        ref={frameRef}
                        className="w-full h-full"
                        src={p.videoUrl}
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        title={`Démo ${p.title}`}
                      />
                      <button
                        onClick={() => setPlayingId(null)}
                        className="absolute top-3 right-3 text-xs font-semibold px-2 py-1 rounded-md bg-[#2a2b31]/90 text-white hover:bg-[#7950F2]"
                      >
                        Fermer
                      </button>
                    </div>
                  ) : (
                    <div className="relative aspect-[16/9] w-full">
                      {p.image ? (
                        <img
                          src={p.image}
                          alt={p.title}
                          className="absolute inset-0 w-full h-full object-cover"
                          loading="lazy"
                        />
                      ) : (
                        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#30204d] via-[#1e1f25] to-[#101116] text-[#d6c7ff] font-medium text-center px-6">
                          Démonstration du projet
                        </div>
                      )}
                      {videoAllowed && (
                        <button
                          onClick={() => setPlayingId(p.id)}
                          className="absolute inset-0 grid place-items-center bg-black/20 hover:bg-black/30 transition"
                          aria-label="Lire la vidéo"
                          title="Lire la vidéo"
                        >
                          <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/90 text-[#0f0f11] font-bold">
                            ▶
                          </span>
                        </button>
                      )}
                    </div>
                  )}
                </div>

                {/* --- Contenu --- */}
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="text-white font-semibold text-lg leading-snug mb-3">
                    {p.title}
                  </h3>

                  <div className="flex flex-wrap items-center gap-2 mb-5">
                    {p.tools?.map((t, i) => (
                      <span
                        key={i}
                        className="inline-flex items-center gap-2 bg-[#2a2b31] border border-[#32333b] text-[#cfd2dc] text-xs font-medium px-2.5 py-1.5 rounded-full select-none"
                      >
                        <span className="capitalize">{t}</span>
                      </span>
                    ))}
                  </div>

                  {/* Actions (optionnel) */}
                  <div className="mt-auto flex gap-3">
                    {videoAllowed && !isPlaying && (
  <button
    onClick={() => setPlayingId(p.id)}
    className="px-3.5 py-2.5 rounded-xl
               bg-[#7950F2] text-[#ffff] font-semibold text-sm
               border border-[#7049e6]
               hover:bg-transparent hover:text-[#cbb5ff]
               transition"
  >
    Voir la vidéo
  </button>
)}
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </div>
  );
}
